import { MultiSelectFieldSync, MultiSelectFieldSyncProps } from '@servicetitan/anvil2/beta';
import { Controller, get, useFormContext } from 'react-hook-form';

export interface MultiSelectFieldOption {
    id: string | number;
    label: string;
    disabled?: boolean;
}

export interface MultiSelectFieldProps
    extends Omit<MultiSelectFieldSyncProps, 'onSelectedOptionsChange' | 'value' | 'options'> {
    name: string;
    options: MultiSelectFieldOption[];
    onChange?: (value: MultiSelectFieldOption[]) => void;
}

export const MultiSelectField = ({ name, onChange, options, ...props }: MultiSelectFieldProps) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = get(errors, name);
    const errorMessage = error?.message;

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => {
                const selectedIds: (string | number)[] = field.value ?? [];
                const selectedOptions = options.filter(option => selectedIds.includes(option.id));

                return (
                    <MultiSelectFieldSync
                        {...props}
                        options={options}
                        value={selectedOptions}
                        onSelectedOptionsChange={newOptions => {
                            const ids = newOptions.map(o => o.id);
                            field.onChange(ids);
                            onChange?.(newOptions);
                        }}
                        error={errorMessage}
                    />
                );
            }}
        />
    );
};
